import { IntlShape } from 'react-intl'
import { create, enforce, group, omitWhen, test } from 'vest'
import {
  MoreForLessBenefitVariant,
  MoreForLessEffect,
} from '../../../../../../typings'
import { messages } from './messages'

export function benefitValidationSuite(intl: IntlShape, name = '') {
  return create(
    ({ trigger, benefit }: NonNullableObject<MoreForLessEffect>) => {
      const { $t } = intl
      const { validation } = messages

      group('benefit', () => {
        test(`${name}.quantity`, $t(validation.minValue, { value: 0 }), () => {
          enforce(benefit.quantity).gt(0)
        })

        omitWhen(!trigger.minQuantity, () => {
          test(
            `${name}.quantity`,
            $t(validation.quantityMaxValue, {
              minQuantity: trigger.minQuantity,
            }),
            () => {
              enforce(benefit.quantity).lte(trigger.minQuantity)
            }
          )
        })

        test(
          `${name}.discount.value`,
          $t(validation.minValue, { value: 0 }),
          () => {
            enforce(benefit.discount.value).gt(0)
          }
        )

        omitWhen(
          benefit.discount.type !== MoreForLessBenefitVariant.PERCENTUAL,
          () => {
            test(
              `${name}.discount.value`,
              $t(validation.maxValue, { value: 100 }),
              () => {
                enforce(benefit.discount.value).lte(100)
              }
            )
          }
        )
      })
    }
  )
}
